import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StoreVariableService {

  private previousUrl: string;
  private currentUrl: string;

  constructor(private http: HttpClient,private router: Router) {
    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {        
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      };
    });
   }
  listingData: any = [];
  breadCrumb:any= {
    l1_actual_name: '',
    l2_actual_name: '',
    l3_actual_name: '',
    l4_actual_name: '',
    filterCount: 0,
  };

  newsearchDataList:any=[];
  newlevel2Data:any[] = [];

  level3DataImages=[]
  productDetailsData :any = [];
  level3data: any[] = [];
  productPrice: any;


vcNumber:any;
  smartFilterData: any = [];
  json: Input1 = {
    deck_length: null,
    cabin_type: null,
    wheels: null,
    feature_premium: null,
    tyre_type: null,
    color: null,
    deck_type: null,
    no_seats: null,
    brand: null,
    air_conditioning: null,
    fuel_type: null,
    body_type: null,
    roof_type: null,
    sleeping_option: null,
    body_option: null,
    tonnage: null,
    engine_power: null,
    body_size: null,
    suspension_type: null,
    engine_type: null,
    colour: null,
    ventilation: null,
    wheelbase: null,
    payload: null,
    wheel_drive: null,
    engine:null,
    RMC_Drum_Size: null
  }
  public isclick =new BehaviorSubject<boolean>(false);
  isclickid:any=0;
isSmart=false
  productlistdata:any;
  TotalCount_List = []
  TotalFIlters = 0
  public getPreviousUrl() {
    return this.previousUrl;
  } 
  public getCurrentUrl() {
    return this.currentUrl;
  } 
}
export interface Input1 {
  feature_premium: any;
  tyre_type: any;
  deck_length: any;
  color: any;
  deck_type: any;
  no_seats: any;
  brand: any;
  air_conditioning: any;
  cabin_type: any;
  wheels: any;
  fuel_type: any;
  body_type: any;
  roof_type: any;
  sleeping_option: any;
  body_option: any;
  tonnage: any;
  engine_power: any;
  body_size: any;
  suspension_type: any;
  engine_type: any;
  colour: any;
  ventilation: any;
  wheelbase: any;
  payload: any;
  wheel_drive: any;
  engine:any;
  RMC_Drum_Size: any;
}